<div id="table-row-container">
  <!-- Checkbox -->
  <mat-checkbox
    *ngIf="this.data.estado != 'W'; else template1"
    [checked]="this.data.checked"
    color="primary"
    (change)="checkboxChange($event.checked)"
  >
  </mat-checkbox>
  <ng-template #template1>
    <div id="nocheck"></div>
  </ng-template>
  <!-- Agente - Nombre -->
  <div id="agent">
    <p id="name" class="subheading-01-semi-bold">
      {{ this.data.nombreReceptor }}
      {{ this.data.apellidoReceptor }}
    </p>
    <!-- Agente - CUIT -->
    <p class="paragraph-01-regular">[{{ this.data.cuitReceptor }}]</p>
  </div>
  <!-- Fecha -->
  <div id="date">
    <p class="paragraph-01-regular">
      {{ this.data.fechaEmision | date : "d/M/y" }}
    </p>
  </div>
  <!-- Nota credito -->
  <div id="credit-note" *ngIf="this.data.cbteAsociado; else receipt">
    <p class="paragraph-01-regular">{{ this.data.numCbte }}</p>
    <qr-icon
      *ngIf="this.data.estado == 'A'"
      matTooltip="Comprobante asociado {{ this.data.cbteAsociado.numCbte }}"
      name="document"
      color="primary-700"
    ></qr-icon>
  </div>
  <ng-template #receipt>
    <!-- Comprobante -->
    <div id="receipt">
      <p class="paragraph-01-regular">{{ this.data.numCbte }}</p>
    </div>
  </ng-template>
  <!-- Neto -->
  <div id="net">
    <p class="paragraph-01-regular">
      {{ this.data.tipoMoneda == "PES" ? "$" : "U$S" }}
      {{ this.data.importeNetoGravado | number : "1.0-2" }}
    </p>
  </div>
  <!-- IVA -->
  <div id="iva">
    <p class="paragraph-01-regular">
      {{ this.data.tipoMoneda == "PES" ? "$" : "U$S" }}
      {{ this.data.importeIVA | number : "1.0-2" }}
    </p>
  </div>
  <!-- Total -->
  <div id="total">
    <p class="paragraph-01-regular">
      {{ this.data.tipoMoneda == "PES" ? "$" : "U$S" }}
      {{ this.data.importeTotal | number : "1.0-2" }}
    </p>
  </div>
  <!-- CAE - Icono -->
  <div id="cae-icon">
    <div *ngIf="this.icon" [matTooltip]="this.tooltip">
      <qr-icon [name]="this.icon.name" [color]="this.icon.color"></qr-icon>
    </div>
  </div>
  <!-- CAE - Estado -->
  <div id="cae">
    <p class="paragraph-01-regular">{{ this.data.cae }}</p>
  </div>
  <!-- Acciones -->
  <div id="actions" *ngIf="this.data.estado != 'W'; else template2">
    <qr-button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [config]="kebabButtonConfig"
      class="button-container"
      matTooltip="Mas opciones"
    ></qr-button>

    <!-- Menu Options -->
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        *ngIf="this.data.estado == 'E' || this.data.estado == 'B'"
      >
        <div class="menu-billing" (click)="onActionMenu('delete')">
          <qr-icon name="delete" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Eliminar</p>
        </div>
      </button>
      <button mat-menu-item *ngIf="this.data.estado == 'B'">
        <div class="menu-billing" (click)="onActionMenu('cae')">
          <qr-icon name="solicitate-cae" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Solicitar CAE</p>
        </div>
      </button>
      <button mat-menu-item *ngIf="this.data.estado == 'A'">
        <div class="menu-billing" (click)="onActionMenu('download')">
          <qr-icon name="download-2" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Descargar</p>
        </div>
      </button>
      <button mat-menu-item *ngIf="this.data.estado == 'A'">
        <div class="menu-billing" (click)="onActionMenu('email')">
          <qr-icon name="send-email" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Enviar e-mail</p>
        </div>
      </button>
      <button
        mat-menu-item
        *ngIf="
          this.data.estado == 'A' &&
          this.data.numCbte.includes('FC') &&
          !this.data.cbteAsociado
        "
      >
        <div class="menu-billing" (click)="onActionMenu('credit')">
          <qr-icon name="document" color="grey-600"></qr-icon>
          <p class="subheading-01-semi-bold">Generar nota de crédito</p>
        </div>
      </button>
    </mat-menu>
  </div>

  <ng-template #template2>
    <div id="noactions"></div>
  </ng-template>
</div>
